import React from 'react';
import './TopMenu.scss';
import TelegramIcon from '@mui/icons-material/Telegram';
import HelpIcon from '@mui/icons-material/Help';
import { menuRef } from '../../../../Modules/MenuModel/MenuLogic';
import { NavLink } from 'react-router-dom';
import ThemeToggle from '../../../../theme/ThemeToggle';

const TopMenu = () => {
  return (
    <div className='topMenu_container'>
      <div className="topMenuRef_block">
        {
          menuRef?.map((e) => {
            const cls = 'link_menu';
            // Метка та же, что в мобильном меню, но без стрелки ↗:
            // в десктопной строке она лишняя, пункт и так один внешний.
            const label = (
              <>
                {e.name}
                {e.isNew && <span className="topMenu_badge">Новое</span>}
              </>
            );
            // external — другой домен, NavLink увёл бы на несуществующий роут
            return e.external
              ? <a href={e.path} className={cls} key={e.name}>{label}</a>
              : <NavLink to={e.path} className={cls} key={e.name}>{label}</NavLink>;
          })
        }
      </div>
      <div className="topMenuService_block">
        <div className="topMenuService_item">
          <TelegramIcon className='topMenuService_icon'/>
          <p>Душанбе</p>
        </div>
        <div className="topMenuService_item">
          <HelpIcon className='topMenuService_icon'/>
          <p>Поддержка</p>
        </div>
        <ThemeToggle className="themeToggle--compact" />
      </div>
    </div>
  );
}

export default TopMenu;
